(function () {
    const ALGOLIA_LOG_PREFIX = '[po-cart-accessories]';

    const getAccessoriesContainer = (root) => root?.closest?.('.po-accessories-container') || null;
    const shouldDeferReveal = (root) =>
        getAccessoriesContainer(root)?.dataset?.poAccessoriesDeferredReveal === 'true';
    const requiresCartTrigger = (root) => root?.dataset?.loadOnCartEvent === 'true';

    function hideAccessoriesContainer(root) {
        const container = getAccessoriesContainer(root);
        container?.classList?.add('tw-hidden');
    }

    function showAccessoriesContainer(root) {
        const container = getAccessoriesContainer(root);
        container?.classList?.remove('tw-hidden');
    }

    const fetchHandlesFromAlgolia = (collectionHandle, limit, ruleContext) => {
        const helper = window.poAlgoliaFetchCollectionHandles;
        if (typeof helper === 'function') {
            return helper({
                collectionHandle,
                limit,
                ruleContext,
                includeMetadata: true,
                includeCollectionHandleInRuleContexts: false,
                logPrefix: ALGOLIA_LOG_PREFIX,
                debugLabel: 'Algolia handles:',
                errorLabel: 'fetchHandlesFromAlgolia error',
            });
        }
        console.error(ALGOLIA_LOG_PREFIX, 'Helper poAlgoliaFetchCollectionHandles mancante');
        return Promise.resolve([]);
    };

    function annotateAlgoliaTracking(root, item) {
        if (!(root instanceof Element) || typeof window.poAlgoliaInsights?.annotateElement !== 'function') {
            return;
        }

        const algoliaItem = {
            ...item,
            source: 'cart-accessories',
        };
        const targets = [
            root,
            ...root.querySelectorAll(
                'a[href*="/products/"], product-form, .po-algolia-product-card, .card-product--container, .card-product--info, [type="submit"], .js-add-to-cart'
            ),
        ];

        targets.forEach((target) => window.poAlgoliaInsights.annotateElement(target, algoliaItem));
    }

    function applyAlgoliaTrackingToCardMarkup(html, item) {
        if (!html || !item) {
            return html;
        }

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        annotateAlgoliaTracking(wrapper, item);
        return wrapper.innerHTML;
    }

    async function fetchProductCardHTML(item) {
        const handle = typeof item === 'string' ? item : item?.handle;
        const cacheKey = `${handle}|po-cart-accessory-card`;
        const cache = window.poAlgoliaCache?.cards;

        if (cache?.has(cacheKey)) {
            const rawHtml = await cache.get(cacheKey);
            return applyAlgoliaTrackingToCardMarkup(rawHtml, item);
        }

        const promise = (async () => {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const url = `${root}products/${encodeURIComponent(handle)}?view=po-cart-accessory-card`;

        try {
            const res = await fetch(url, {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'fetch' },
            });
            if (!res.ok) {
                console.warn('[po-cart-accessories] product card non-OK', url, res.status);
                return '';
            }

            const text = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const cardWrapper = doc.querySelector('#po-cart-accessory-card');
            const cardElement =
                cardWrapper?.querySelector('.card-product--container') || cardWrapper?.firstElementChild;

            if (!cardWrapper || !cardElement) {
                console.warn('[po-cart-accessories] #po-cart-accessory-card non trovato per handle', handle);
                return '';
            }

            // Include inline styles from the snippet to preserve the original layout
            return cardWrapper.innerHTML;
        } catch (e) {
            console.error('[po-cart-accessories] fetchProductCardHTML error', handle, e);
            return '';
        }
        })();

        if (cache) {
            const pending = promise.then((html) => {
                if (!html) {
                    cache.delete(cacheKey);
                    return '';
                }
                cache.set(cacheKey, Promise.resolve(html));
                return html;
            });
            cache.set(cacheKey, pending);
            const rawHtml = await pending;
            return applyAlgoliaTrackingToCardMarkup(rawHtml, item);
        }

        const rawHtml = await promise;
        return applyAlgoliaTrackingToCardMarkup(rawHtml, item);
    }

    function renderSkeleton(wrapper, limit, cardClasses) {
        wrapper.innerHTML = '';
        const count = Math.max(1, limit);

        for (let i = 0; i < count; i++) {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide tw-h-auto';

            const container = document.createElement('div');
            container.className = cardClasses;

            // Placeholder immagine + testo
            container.innerHTML = `
        <div class="card-product--image-wrapper tw-w-full tw-mb-po-spacings-base">
          <div class="tw-w-full tw-aspect-[4/3] tw-bg-po-secondary tw-animate-pulse tw-rounded"></div>
        </div>
        <div class="card-product--info tw-flex tw-flex-col tw-gap-2">
          <div class="tw-h-4 tw-w-3/4 tw-bg-po-secondary tw-animate-pulse tw-rounded"></div>
          <div class="tw-h-3 tw-w-1/2 tw-bg-po-secondary tw-animate-pulse tw-rounded"></div>
          <div class="tw-mt-po-spacings-sm tw-h-4 tw-w-1/3 tw-bg-po-secondary tw-animate-pulse tw-rounded"></div>
        </div>
      `;

            slide.appendChild(container);
            wrapper.appendChild(slide);
        }
    }

    async function initCartAccessories(root) {
        if (!root || root.dataset.poAccessoriesLoaded === 'true' || root.dataset.poAccessoriesLoading === 'true') {
            return;
        }

        root.dataset.poAccessoriesLoading = 'true';
        const collectionHandle = root.dataset.collectionHandle || '';
        const ruleContext = root.dataset.ruleContext || '';
        const limit = parseInt(root.dataset.limit || '4', 10);
        const cardClasses = root.dataset.cardClasses || '';

        const wrapper = root.querySelector('.swiper-wrapper');
        if (!wrapper) {
            root.dataset.poAccessoriesLoading = 'false';
            return;
        }

        try {
            // 1) Verifico prima se Algolia ha risultati per evitare flash del blocco vuoto
            let items = await fetchHandlesFromAlgolia(collectionHandle, limit, ruleContext);
            if (!items.length && ruleContext && ruleContext !== 'CART') {
                items = await fetchHandlesFromAlgolia(collectionHandle, limit, 'CART');
            }
            if (!items.length) {
                wrapper.innerHTML = '';
                hideAccessoriesContainer(root);
                root.dataset.poAccessoriesLoaded = 'true';
                return;
            }

            // 2) Se ho risultati, mostro subito lo skeleton mentre recupero le card HTML
            renderSkeleton(wrapper, limit, cardClasses);
            showAccessoriesContainer(root);
            root.dispatchEvent(new CustomEvent('po:cart-accessories:ready', { bubbles: true }));

            const cards = await Promise.all(
                items.map(async (item) => ({
                    item,
                    html: await fetchProductCardHTML(item),
                }))
            );

            const fragment = document.createDocumentFragment();
            let renderedCards = 0;

            for (const { html } of cards) {
                if (!html) continue;

                const slide = document.createElement('div');
                slide.className = 'swiper-slide tw-h-auto';

                const container = document.createElement('div');
                container.className = cardClasses;
                container.innerHTML = html;

                slide.appendChild(container);
                fragment.appendChild(slide);
                renderedCards += 1;
            }

            if (!renderedCards) {
                wrapper.innerHTML = '';
                hideAccessoriesContainer(root);
                root.dataset.poAccessoriesLoaded = 'true';
                return;
            }

            wrapper.innerHTML = '';
            wrapper.appendChild(fragment);

            // Notifico che le card sono pronte (se serve a script esterni)
            root.dispatchEvent(new CustomEvent('po:cart-accessories:ready', { bubbles: true }));
            root.dataset.poAccessoriesLoaded = 'true';
        } catch (error) {
            console.error(ALGOLIA_LOG_PREFIX, 'initCartAccessories error', error);
        } finally {
            root.dataset.poAccessoriesLoading = 'false';
        }
    }

    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    function startViewportObservation(root) {
        if (!root || root.dataset.poAccessoriesViewportObserved === 'true') return;
        root.dataset.poAccessoriesViewportObserved = 'true';
        const load = () => initCartAccessories(root);

        if (shouldDeferReveal(root)) {
            load();
            return;
        }

        if (typeof IntersectionObserver !== 'function') {
            load();
            return;
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                obs.disconnect();
                load();
            });
        }, { threshold: 0.2 });

        observer.observe(root);
    }

    function waitForCartTrigger(root, callback) {
        if (!root || root.dataset.poAccessoriesCartTriggerBound === 'true') return;
        root.dataset.poAccessoriesCartTriggerBound = 'true';

        let isTriggered = false;
        let unsubscribeCartUpdate = null;

        const cleanup = () => {
            document.removeEventListener('po:cart:item-added', handleCartItemAdded);
            if (typeof unsubscribeCartUpdate === 'function') {
                unsubscribeCartUpdate();
                unsubscribeCartUpdate = null;
            }
        };

        const activate = () => {
            if (isTriggered) return;
            isTriggered = true;
            cleanup();
            callback();
        };

        const handleCartItemAdded = () => activate();
        document.addEventListener('po:cart:item-added', handleCartItemAdded, { passive: true });

        const cartUpdateEvent =
            typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS?.cartUpdate : 'cart-update';

        if (typeof window.subscribe === 'function') {
            unsubscribeCartUpdate = window.subscribe(cartUpdateEvent, (event = {}) => {
                const source = event?.source;
                if (source === 'product-form' || source === 'quick-add') {
                    activate();
                }
            });
        }
    }

    function observeAccessoriesWhenVisible(root) {
        if (!root || root.dataset.poAccessoriesObserved === 'true') return;
        root.dataset.poAccessoriesObserved = 'true';

        if (requiresCartTrigger(root)) {
            waitForCartTrigger(root, () => initCartAccessories(root));
            return;
        }

        startViewportObservation(root);
    }

    onReady(() => {
        document
            .querySelectorAll('swiper-slider[data-po-cart-accessories="true"]')
            .forEach((root) => observeAccessoriesWhenVisible(root));
    });
})();
